import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "fullscreenMenu" ]

  toggleNav() {
    const element = this.fullscreenMenuTarget;
    element.classList.toggle('hidden');
  }
}
